import { PayPalButtons } from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function PayPalCheckout() {
  const navigate = useNavigate();
  const { updateUserPaymentStatus } = useAuth();

  const handlePaymentSuccess = async (paymentDetails) => {
    console.log("Payment successful:", paymentDetails);
    try {
      await updateUserPaymentStatus(true);
      navigate("/profile/edit", { replace: true });
    } catch (error) {
      console.error("Error updating payment status:", error);
    }
  };

  const handlePaymentError = (error) => {
    console.error("PayPal error:", error);
    navigate("/payment/error", {
      state: {
        errorDetails: error?.message || String(error),
      },
      replace: true,
    });
  };

  return (
    <PayPalButtons
      createOrder={async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:3000"}/api/v1/payments/create_order`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include"
        });

        const orderData = await response.json();

        if (!response.ok) {
          throw new Error(orderData.error || "Payment creation failed");
        }

        return orderData.id;
      }}

      onApprove={async (data, actions) => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:3000"}/api/v1/payments/capture_order`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ order_id: data.orderID }),
            credentials: "include"
          });

          const captureData = await response.json();
          if (captureData.success) {
            await handlePaymentSuccess(captureData);
          } else {
            throw new Error(captureData.error || "Payment capture failed");
          }
        } catch (error) {
          handlePaymentError(error);
        }
      }}
      onError={handlePaymentError}
    />
  );
}
